import { createContext, useContext } from 'react';
const EmbedModalContext = /*#__PURE__*/createContext(null);
export const EmbedModalProvider = EmbedModalContext.Provider;
export const useEmbedModal = () => useContext(EmbedModalContext);